export function getEnvironmentVariables() {
  // Vite variables.
  const mode = import.meta.env.MODE; // 'dev', 'stage', 'prod' ('development' in dev mode)
  const dev = import.meta.env.DEV; // true if running in dev mode

  const packageFqn = `${__APP_NAME__}@${__APP_VERSION__}`;

  const appTitle = import.meta.env.VITE_APP_TITLE;
  const assetsBaseUrl = import.meta.env.VITE_ASSETS_BASE_URL;
  const socraitApiUrl = import.meta.env.VITE_SOCRAIT_API_URL;
  const webClientId = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID;
  const flagsmithEnvironmentId = import.meta.env.VITE_FLAGSMITH_ENVIRONMENT_ID;
  const useSentry = import.meta.env.VITE_USE_SENTRY;
  const isMockMode = !!import.meta.env.VITE_MOCK_SERVICE_WORKER;
  const googleAdsId = import.meta.env.VITE_GOOGLE_ADS_ID;
  const googleAdsLabelPageView = import.meta.env.VITE_GOOGLE_ADS_LABEL_PAGE_VIEW;
  const googleAdsLabelLogin = import.meta.env.VITE_GOOGLE_ADS_LABEL_LOGIN;
  const googleAdsLabelSetup = import.meta.env.VITE_GOOGLE_ADS_LABEL_SETUP;
  const turnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;

  // Vite defaults the mode to 'development' when running locally which could be confused
  // with the 'dev' mode, so use 'local' to be more explicit.
  const environment = dev ? 'local' : mode;
  const isDeployed = ['dev', 'prod'].includes(environment);
  const isProduction = environment === 'prod';

  return {
    environment,
    isDeployed,
    isProduction,
    packageFqn,
    appTitle,
    assetsBaseUrl,
    socraitApiUrl,
    webClientId,
    flagsmithEnvironmentId,
    useSentry,
    isMockMode,
    googleAdsId,
    googleAdsLabelPageView,
    googleAdsLabelLogin,
    googleAdsLabelSetup,
    turnstileSiteKey,
  };
}

export type Environment = ReturnType<typeof getEnvironmentVariables>;
